import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import TermsPage from "@/pages/TermsPage";
import SupportIQPage from "@/pages/SupportIQPage";
import DeliverIQPage from "@/pages/DeliverIQPage";
import MildSteelStaircasePage from "@/pages/MildSteelStaircasePage";
import StainlessSteelTankFarmPage from "@/pages/StainlessSteelTankFarmPage";
import StainlessSteelHandrailPage from "@/pages/StainlessSteelHandrailPage";
import StainlessSteelHopperPage from "@/pages/StainlessSteelHopperPage";

const ConditionalFooter = () => {
  const location = useLocation();
  const hideFooterRoutes = ["/supportiq", "/deliveriq"];
  if (hideFooterRoutes.includes(location.pathname)) return null;
  return <Footer />;
};

function App() {
  return (
    <div className="App min-h-screen bg-slate-950 text-slate-50">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/mild-steel-staircase" element={<MildSteelStaircasePage />} />
            <Route path="/projects/stainless-steel-tank-farm" element={<StainlessSteelTankFarmPage />} />
            <Route path="/projects/stainless-steel-handrail" element={<StainlessSteelHandrailPage />} />
            <Route path="/projects/stainless-steel-hopper" element={<StainlessSteelHopperPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/supportiq" element={<SupportIQPage />} />
            <Route path="/deliveriq" element={<DeliverIQPage />} />
          </Routes>
        </main>
        <ConditionalFooter />
        <CookieConsent />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
